/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_SalaryInputs */

const en_nav_salary = /** @type {(inputs: Nav_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary`)
};

const de_nav_salary = /** @type {(inputs: Nav_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehalt`)
};

const fr_nav_salary = /** @type {(inputs: Nav_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salaire`)
};

const es_nav_salary = /** @type {(inputs: Nav_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salario`)
};

const it_nav_salary = /** @type {(inputs: Nav_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stipendio`)
};

const nl_nav_salary = /** @type {(inputs: Nav_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salaris`)
};

const pl_nav_salary = /** @type {(inputs: Nav_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wynagrodzenie`)
};

const fi_nav_salary = /** @type {(inputs: Nav_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palkka`)
};

const da_nav_salary = /** @type {(inputs: Nav_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Løn`)
};

const sv_nav_salary = /** @type {(inputs: Nav_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lön`)
};

/**
* | output |
* | --- |
* | "Salary" |
*
* @param {Nav_SalaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_salary = /** @type {((inputs?: Nav_SalaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_SalaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_salary(inputs)
	if (locale === "fr") return fr_nav_salary(inputs)
	if (locale === "es") return es_nav_salary(inputs)
	if (locale === "it") return it_nav_salary(inputs)
	if (locale === "nl") return nl_nav_salary(inputs)
	if (locale === "pl") return pl_nav_salary(inputs)
	if (locale === "fi") return fi_nav_salary(inputs)
	if (locale === "da") return da_nav_salary(inputs)
	if (locale === "sv") return sv_nav_salary(inputs)
	return en_nav_salary(inputs)
});